// @ts-strict-ignore
import ProvidersLogoModules from '../../../providers-logo-modules'
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from '../../../../types/fs-core'
import { brand, trustpilot } from '../../../../redux/app-selectors'
import { Button, Trustpilot as TrustpilotAtom, type TrustpilotData } from '../../../../atoms'

interface CardFinderLowProminenceProps {
  jsonBody: any
  name: string
  variant: string
  rawName: string
  brand: 'money' | 'uswitch'
  sys: {
    id: string
  }
  dataset: any
  trustpilotData: TrustpilotData | undefined
}

const CardFinderLowProminence: React.FC<CardFinderLowProminenceProps> = ({
  trustpilotData,
  jsonBody,
  name,
  variant,
  rawName,
  brand,
  sys,
  dataset,
}) => {
  const eligibilityCheckUrl =
    brand === 'uswitch'
      ? '/credit-cards/eligibility-checker/form/'
      : '/credit-cards/eligibility-checker'
  const {
    title,
    subtitle,
    buttonText = 'Get Started',
    ctaIcon = false,
    url = eligibilityCheckUrl,
    subCategory,
    showTrustPilot,
    logosOverrideOrder,
    hideLogosOnMobile,
  } = jsonBody
  const ecUrl =
    url === eligibilityCheckUrl && subCategory ? `${url}?productType=${subCategory}` : url

  try {
    return (
      <div className='CardFinderLowProm' id={name}>
        <h2 className={'CardFinderLowProm__title'}>{title}</h2>
        <div className='CardFinderLowProm__subtitle'>{subtitle}</div>
        <div className={`CardFinderLowProm__providers${hideLogosOnMobile ? '--hideOnMobile' : ''}`}>
          <ProvidersLogoModules
            dataset={dataset}
            orderOverride={logosOverrideOrder || []}
            variant={'cardFinderProviders'}
            name={'CardFinderLowProminence Providers'}
            clickable={false}
            heading={''}
          />
        </div>
        {showTrustPilot && trustpilotData && (
          <TrustpilotAtom trustpilotData={trustpilotData} brand={brand} />
        )}
        <div className='CardFinderLowProm__anchor'>
          <Button
            href={ecUrl}
            /* eslint-disable camelcase */
            dataClickTracking={{
              component_category: 'platinum-component',
              component_id: sys?.id,
              component_name: 'cardFinderLowProm',
              contentful_name: rawName,
              contentful_variant: variant,
              additionalProps: { text: buttonText },
            }}
            variant='primary'
            size='lg'
            withIcon={ctaIcon}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state: FsCore.State, props: any) => ({
  brand: brand(state),
  trustpilotData: trustpilot(state, brand(state)),
  ...props,
}))(CardFinderLowProminence)
